import React, {memo, useEffect, useState} from "react";
import { basePath, doorStyles } from "../../../../lib/constant";
import { useAppContext } from "../../../../context/AppContext";
import { useFormContext, useWatch } from "react-hook-form";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/pro-solid-svg-icons";
import {Popover, PopoverContent, PopoverTrigger} from "../../ui/Popover";


const DooStyleRadioGroup = ({
    register,
    formState: { isDirty },
    control,
    setValue,
    getValues
}) => {
    const {
        state: { view,isOxide },
        setSelectedInternalColourType,
        setSelectedExternallColourType,
    } = useAppContext();


    const selectedOption = useWatch({
        control,
        name: "external_door_style",
    });
    const configuration = useWatch({
        control,
        name: "configuration",
    });
    const glass_option = getValues('glass_option')

    useEffect(() => {
        setValue("external_door_style", selectedOption);
        if(!['tanzania','sumatra'].includes(selectedOption) && !glass_option) {
            setValue('glass_option','clear')
        }
    }, [selectedOption]);

    useEffect(() => {
        if(configuration !== 'none' && !glass_option) {
            setValue('glass_option','clear')
        }
    }, [configuration]);

    return (
        <>
            {doorStyles.map((door) => {
                return (
                    <div key={door} className="group cursor-pointer relative">
                        {door === 'sumatra' &&
                       <div className='absolute -top-5 left-0'>
                           <Popover >
                               <PopoverTrigger>
                                   <FontAwesomeIcon className="text-primary absolute top-0 left-0" icon={faCircleInfo} />
                               </PopoverTrigger>
                               <PopoverContent className='text-center'>Premium Ceramic Finish Available!</PopoverContent>
                           </Popover>
                       </div>
                        }
                        <div className="relative flex flex-col items-center h-28 group-has-[:checked]:bg-[#555454] p-1">
                            <input
                                className="absolute inset-0 h-full w-full opacity-0 z-20 cursor-pointer"
                                type="radio"
                                id="external_door_style"
                                value={door}
                                {...register("external_door_style", {
                                    onChange: (event) => {

                                        if (event.target.value !== "sumatra" && isOxide) {
                                            // Reset external frame colour
                                            setSelectedExternallColourType("standard");
                                            setValue("external_door_colour", "ral_7016");
                                            setValue('external_door_colour_type','standard');

                                            // Reset external slab colour if it was oxide
                                            setValue("panel", "ral_7016");
                                            setValue('external_slab_colour_type','standard');

                                            // Reset internal colour if it was oxide
                                            setSelectedInternalColourType("standard");
                                            setValue("internal_door_colour", "ral_7016");
                                            setValue('internal_door_colour_type','standard');

                                            // Reset internal slab colour if it was oxide
                                            setValue("internal_slab_colour", "ral_7016");
                                            setValue('internal_slab_colour_type','standard');
                                        }
                                    },
                                })}
                            />
                            <div className="relative w-full h-full">
                                <img
                                    className="absolute inset-0 h-full w-full object-contain"
                                    src={`${basePath}/${door}/standard/${view}/preview.png`}
                                    alt={door}
                                />
                            </div>
                            <p className="text-gray-700 text-xs group-has-[:checked]:text-white capitalize text-center">
                                {door}
                            </p>
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default DooStyleRadioGroup;
